import { ObjectSpacingPopover } from "@/appComponents/Navigation/ContextualToolbar/ObjectSpacingPopover/ObjectSpacingPopover";

export const ObjectSpacingCompositePopover = props => {
  const updateKey = props.updateKey;
  const handleChange = nextValue => {
    const spacing = props.spacing.Clone();
    spacing[updateKey] = nextValue[updateKey];
    props.setSpacing({ spacing, updateKey });
  };

  return (
    <ObjectSpacingPopover
      openCtrlRef={props.openCtrlRef}
      disabled={props.disabled}
      updateKey={props.updateKey}
      icon={props.icon}
      triggerTestId={props.triggerTestId}
      value={{
        [updateKey]: props.spacing[updateKey]
      }}
      title={props.title}
      onChange={handleChange}
      toolbarPopoverProps={props.toolbarPopoverProps}
    />
  );
};
